import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Layout from './views/layout/Layout.vue'

Vue.use(Router)

export default new Router({
  routes: [
	  {
		  path: '/contractInfo',
		  component: Layout,
		  redirect: '/contractInfo/coninfo',
		  name: 'coninfo',
		  meta: {title: 'con_info'},
		  children: [
			{
			  path: 'coninfo',
			  name: 'coninfo',
			  component: () => import('./views/contractInfo/coninfo.vue'),
			  meta:{title:'con_info'},
			},
			
		],
	  },
	  {
	      path: '/process',
	      component: Layout,
	      redirect: '/process/process',
	      name: 'process',
	      meta: { title: 'process_view' },
	      children: [
	  		{
	  		  path: 'process',
	  		  name: 'process',
	  		  component: () => import('./views/process/process.vue'),
	  		  meta: { title: 'process_view' }
	  		}
	  
	  	]
	  },
	{
	    path: '/user',
	    component: Layout,
	    redirect: '/user/personal',
	    name: 'User',
	    meta: {title: 'personal_center'},
	    children: [
			{
			  path: 'personal',
			  name: 'personal',
			  component: () => import('./views/user/personalCenter.vue'),
			  meta:{title:'personal_center'}
			},
	      {
	        path: 'message',
	        name: 'message',
	        component: () => import('./views/user/message.vue'),
	        meta: {title: 'messages'}
	      },
		  {
		    path: 'notice',
		    name: 'notice',
		    component: () => import('./views/user/notice.vue'),
		    meta: {title: 'notice'}
		  },
		  {
		    path: 'record',
		    name: 'record',
		    component: () => import('./views/user/loginRecord.vue'),
		    meta: {title: 'my_record'}
		  },
		  {
		    path: 'information',
		    name: 'information',
		    component: () => import('./views/user/information.vue'),
		    meta: {title: 'my_information'}
		  },
	    ]
	},
    // {
    //   path: '/layout',
    //   name: 'layout',
    //   component: () => import('./views/layout/Layout.vue')
    // },
	{
	    path: '/work',
	    component: Layout,
	    redirect: '/work/mywork',
	    name: 'Work',
	    meta: {title: 'Works_management'},
	    children: [
			{
			  path: 'management',
			  name: 'management',
			  component: () => import('./views/work/management.vue'),
			  meta:{title:'Works_management'}
			},
			{
			  path: 'mywork',
			  name: 'mywork',
			  component: () => import('./views/work/workList.vue'),
			  meta:{title:'My_creation'}
			},
			{
			  path: 'new',
			  name: 'new',
			  component: () => import('./views/work/newWork.vue'),
			  meta:{title:'new_work'}
			},
			{
			  path: 'edit',
			  name: 'edit',
			  component: () => import('./views/work/editWork.vue'),
			  meta:{title:'edit_work'}
			},
			{
			  path: 'setup',
			  name: 'setup',
			  component: () => import('./views/work/setup.vue'),
			  meta:{title:'New_setting',isBack:true}
			},
			{
			  path: 'signingManagement',
			  name: 'signingManagement',
			  component: () => import('./views/work/signingManagement.vue'),
			  meta:{title:'Sign_management',isBack:true}
			},
			{
			  path: 'writing',
			  name: 'writing',
			  component: () => import('./views/work/writing.vue'),
			  meta:{title:'to_write',isBack:true}
			},
			{
			  path: 'workTypeList',
			  name: 'workTypeList',
			  component: () => import('./views/work/workTypeList.vue'),
			  meta:{title:'to_write',isBack:true}
			},
		],
	},
	{
	    path: '/interactive',
	    component: Layout,
	    redirect: '/interactive/space',
	    name: 'Interactive',
	    meta: {title: 'interactive_space'},
	    children: [
			{
			  path: 'space',
			  name: 'space',
			  component: () => import('./views/interactive/interactiveSpace.vue'),
			  meta:{title:'interactive_space'}
			},
			{
			  path: 'comment',
			  name: 'comment',
			  component: () => import('./views/interactive/releaseComment.vue'),
			  meta:{title:'Comment_management',isBack:true}
			},
			{
			  path: 'commentManage',
			  name: 'commentManage',
			  component: () => import('./views/interactive/commentManage.vue'),
			  meta:{title:'Comment_management',isBack:true}
			},
			{
			  path: 'commentDetail',
			  name: 'commentDetail',
			  component: () => import('./views/interactive/commentDetial.vue'),
			  meta:{title:'Comment_details',isBack:true}
			},
		],
	},
	{
	    path: '/data',
	    component: Layout,
	    redirect: '/data/center',
	    name: 'Data',
	    meta: {title: 'data_center'},
	    children: [
			{
			  path: 'center',
			  name: 'center',
			  component: () => import('./views/data/center.vue'),
			  meta:{title:'data_center'}
			},
			{
			  path: 'reading',
			  name: 'reading',
			  component: () => import('./views/data/reading.vue'),
			  meta:{title:'number_readings'}
			},
			{
			  path: 'articleUnlock',
			  name: 'articleUnlock',
			  component: () => import('./views/data/articleUnlock.vue'),
			  meta:{title:'Article_unlock'}
			},
			{
			  path: 'likes',
			  name: 'likes',
			  component: () => import('./views/data/likes.vue'),
			  meta:{title:'Likes'}
			},
			{
			  path: 'collections',
			  name: 'collections',
			  component: () => import('./views/data/collections.vue'),
			  meta:{title:'Favorites'}
			},
		],
	},
	{
	    path: '/income',
	    component: Layout,
	    redirect: '/income/home',
	    name: 'Income',
	    meta: {title: 'my_income'},
	    children: [
			{
			  path: 'home',
			  name: 'home',
			  component: () => import('./views/income/income.vue'),
			  meta:{title:'my_income'}
			},
			{
			  path: 'workIncome',
			  name: 'workIncome',
			  component: () => import('./views/income/workIncome-new.vue'),
			  meta:{title:'Work_income'},
			},
			{
			  path: 'Applywithdrawal',
			  name: 'Applywithdrawal',
			  component: () => import('./views/income/Applywithdrawal.vue'),
			  meta:{title:'Work_income'},
			},
			{
			  path: 'translation',
			  name: 'translation',
			  component: () => import('./views/income/translation.vue'),
			  meta:{title:'Translation_income'}
			},
			{
			  path: 'morebook',
			  name: 'morebook',
			  component: () => import('./views/income/morebook.vue'),
			  meta:{title:'morebook'}
			},
			{
			  path: 'remuneration',
			  name: 'remuneration',
			  component: () => import('./views/income/details/author_remuneration.vue'),
			  meta:{title:'Work_income',childTitle:'total_revenue',isBack:true,}
			},
			{
			  path: 'bonus',
			  name: 'bonus',
			  component: () => import('./views/income/details/bonus.vue'),
			  meta:{title:'Work_income',childTitle:'Incentive_money',isBack:true,}
			},
			{
			  path: 'reward',
			  name: 'reward',
			  component: () => import('./views/income/details/reward.vue'),
			  meta:{title:'Work_income',childTitle:'Reward_details',isBack:true,}
			},
			{
			  path: 'copyright',
			  name: 'copyright',
			  component: () => import('./views/income/details/copyright.vue'),
			  meta:{title:'Work_income',childTitle:'Copyright_income',isBack:true,}
			},
			{
			  path: 'receiptDetails',
			  name: 'receiptDetails',
			  component: () => import('./views/income/details/receiptDetails.vue'),
			  meta:{title:'Work_income',childTitle:'Income_breakdown',isBack:true,}
			},
			{
			  path: 'recordsDetails',
			  name: 'recordsDetails',
			  component: () => import('./views/income/details/recordsDetails.vue'),
			  meta:{title:'Work_income',childTitle:'Income_breakdown',isBack:true,}
			},
		],
	},
	{
	    path: '/setting',
	    component: Layout,
	    name: 'Setting',
	    meta: {title: 'setting'},
	    children: [
			{
			  path: 'setting',
			  name: 'setting',
			  component: () => import('./views/setting.vue'),
			  meta:{title:'setting'}
			},
		],
	},
	{
	    path: '/reviewer',
	    component: Layout,
	    name: 'reviewer',
		redirect: '/reviewer/reviewerWork',
	    meta: {title: 'reviewer'},
	    children: [
			{
			  path: 'reviewerWork',
			  name: 'reviewerWork',
			  component: () => import('./views/reviewer/reviewerWork.vue'),
			  meta:{title:'reviewerWork'}
			},
		],
	},
	{
	    path: '/answer',
	    component: Layout,
	    name: 'Answer',
	    meta: {title: 'FAQs_and_Help'},
	    children: [
			{
			  path: 'answer',
			  name: 'answer',
			  component: () => import('./views/answer.vue'),
			  meta:{title:'FAQs_and_Help'}
			},
		],
	},
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login.vue')
    },
	{
	  path: '/register',
	  name: 'register',
	  component: () => import('./views/register.vue')
	},
	{
	  path: '/resetPwd',
	  name: 'resetPwd',
	  component: () => import( './views/resetPassword.vue')
	},
	{
	  path: '/myinformation',
	  name: 'myinformation',
	  component: () => import( './views/myinformation.vue')
	},
	{
	  path: '/signIn',
	  name: 'signIn',
	  component: () => import( './views/signIn.vue')
	},
	{
	  path: '/404',
	  name: '404',
	  component: () => import( './views/404.vue')
	},
	// {path: '/', redirect: '/user/personal'},
	{path: '/', redirect: '/signIn'},
	{path: '*', redirect: '/404'},

  {
      path: '/author',
      component: Layout,
      name: 'author',
  	redirect: '/author/authorManege',
      meta: {title: 'reviewer'},
      children: [
  		{
  		  path: 'authorManege',
  		  name: 'authorManege',
  		  component: () => import('./views/author/authorManege.vue'),
  		  meta:{title:'author1'}
  		},
		// 作家详情信息
		{
		  path: 'authorInfo',
		  name: 'authorManege',
		  component: () => import('./views/author/authorInfo.vue'),
		  meta:{title:'author1'}
		},
  	],
  },

  ]
})
